import { NavBarLink } from './NavBarLink';
import { SimulatorModuleConfig } from './SimulatorModuleConfig';
import { Subject }  from 'rxjs';
export class SimulatorConfig{
	_debug:false;
    identifier: string;
    static _internal_id=0;
    id;
	default_language: string = 'de_DE';
	default_country: string = 'de';
	available_modules: Map<string,Array<String>>;
	footer_links : Array<NavBarLink>;
	language_file:string;
	show_installation = false;
	menu: string;
	language : string;
	country : string;
	events$:Subject<string>;
    variant : 'vrc720'|'vrc720f';
	footerLinks:Array<NavBarLink>;
    brand:string="";
    customerVersion:boolean=false;
	constructor(data: any){
        this.events$ = new Subject<string>();
		this.construct(data);
        this.variant = 'vrc720';
	}
    isCustomerVersion():boolean{
        return this.customerVersion;
    }
    getLogo(){
        switch(this.brand){
            case 'Saunier Duval':{
                return 'saunier';
            }
            case 'Glow-worm':{
                return 'glowworm';
            }
            case 'Bulex':{
                return 'bulex';
            }
            case 'Protherm':{
                return 'protherm';
            }
            case 'AWB':{
                return 'awb';
            }
            case 'Hermann Saunier Duval':{
                return 'hermann';
            }
            case 'Demir Döküm':{
                return 'demir';
            }
            default:{
                return '';
            }
        }
    }
    customerChoices : any;
    getCountry(){
        return this.country;
    }
    getBrand(): string{
        return this.brand;
    }
	construct(data){
        if(data['customerChoices']){
            this.customerChoices = data['customerChoices'];
        }
		this.id = SimulatorConfig._internal_id;
		SimulatorConfig._internal_id++;
        this.identifier = "default";
        this.moduleConfigs = new Array<SimulatorModuleConfig>();
		if(data['country']){
			this.country = data['country'];
		}else{
			this.debug("Defaulting to country: "+this.default_country);
			this.country = this.default_country;
		}
        if(data['isCustomerVersion']){
            this.customerVersion = data['isCustomerVersion'];
        }else{
            this.customerVersion = false;
        }
		if(data['language']){

			this.language = data['language'];
		}else{
			this.debug("Defaulting to language: "+this.default_language);
			this.language = this.default_language;
		}
		this.footerLinks = new Array<NavBarLink>();
		if(data['footer'] && data['footer']['footerLinks']){
			for(let linkData of data['footer']['footerLinks']){
				this.footerLinks.push(new NavBarLink(linkData));
			}
		}
        if(data['brand']){
            this.brand = data['brand'];
        }
		this.available_modules = new Map<string,Array<string>>();
		if(data['available_modules']){
			for(let idx in data['available_modules']){
                var submodules = new Array<string>();
                for(let mod of data['available_modules'][idx]){
                    submodules.push(mod);
                }
				this.available_modules.set(idx, submodules);
			}

		}
        if(data['menu']){
        	this.menu=data['menu'];
        }else{
        	this.menu='de.menu.json';
        	this.debug("Defaulting to de.menu.json");
        }
        if(data['identifier']){
            this.identifier = data['identifier'];
        }

	}
	configured:boolean=false;
	isConfigured(){
		return this.configured;
	}
	setConfigured(b:boolean){
		this.configured = b;
	}

    moduleConfigs:Array<SimulatorModuleConfig>;
    setModuleConfigs(config : Array<SimulatorModuleConfig>){
    	this.debug(JSON.stringify(config));
    	this.moduleConfigs = config;
        this.events$.next('modules_set');
    }
    getMenuFilename(){
    	return this.menu;
    }
    getModuleConfigs(){
        return this.moduleConfigs;
    }

    getModuleConfigByName(name:string):SimulatorModuleConfig{
    	//this.debug("returning module "+name);
        for(let moduleConfig of this.moduleConfigs){
            if(moduleConfig.getName() == name){
                return moduleConfig;
            }
        }
        //this.debug("module " + name +" not found.");
        return undefined;
    }
	
	moduleAvailable(name:string):boolean{
		this.debug("module availability polled: "+name);
		if(!this.available_modules.has(name)){
			return false;
		}

		if(this.available_modules.get(name).length == 0){
			
			return false;
		}
		return true;
	}

    setIdentifier(identifier : string){
        this.identifier = identifier;
    }

    getIdentifier(){
        return this.identifier;
    }

	subModuleAvailable(name: string, submodule:string):boolean{

		if(this.moduleAvailable(name)){
			if(this.available_modules.get(name).indexOf(submodule) != -1){
                return true;
            }
            if(this.available_modules.get(name).indexOf("*") != -1){
                return true;
            }
		}
        this.debug("Module "+name+":"+submodule+ " is not available.");
		return false;
	}


	debug(str: string){
		if(this._debug){
			console.log(str);
		}
	}

	showInstallation(si?:boolean){
		if(si === true || si === false){
			this.show_installation = si;
		}
		return this.show_installation;
	}

	
	hasVR70(){
        return (this.getVR70Count()>0);
		// vr70 notwendig wenn:
		// heizkreise > 2 || bufferCylinder != no
		/*
		let bcc = this.getModuleConfigByName('bufferCylinder');
		if(bcc.isAvailable() && bcc.getValue() != 'no'){
			return true;
		}
		
		let hcc = this.getModuleConfigByName('heatingCircuits');
		if(hcc.isAvailable()){
			if(hcc.getParameter() == 2){
				return true;
			}
		}
		
		return false;
        */
	}
	hasVR71(){
        return (this.getVR71Count()>0);
        /*
		// allstor, solarspeicher (1 oder 2   ), >2 heizkreise
		let hcc = this.getModuleConfigByName('heatingCircuits');
		if(hcc.isAvailable() && hcc.getParameter() > 2){
			return true;
		}
		let bcc = this.getModuleConfigByName('bufferCylinder');
		if(bcc.isAvailable() && bcc.getValue() == 'allStor'){
			return true;
		}
		let ssc = this.getModuleConfigByName('solarSystem');
		if(ssc.isAvailable() && ssc.getValue() != "no"){
			return true;
		}
		return false;
        */
	}
    justVentilation(){
        if(this.ventilationCount() == 1){
            if(this.boilerCount() > 0){
                return false;
            }
            if(this.heatpumpCount() > 0){
                return false;
            }
            if(this.solarCylinderCount() > 0){
                return false;
            }
            if(this.hasBufferCylinder()){
                return false;
            }
            return true;
        }
        return false;
    }
	hasVR7x(){
		return this.hasVR70() || this.hasVR71();
	}

    heatingCircuitCount():number{
        let active = parseInt(this.getModuleConfigByName('heatingCircuits').getParameter());
        return active;
        let vrc70 = this.getVR70Count();
        let vrc71 = this.getVR71Count();
        if([1,2].includes(active) && vrc70 == 0 && vrc71 == 1){
            return 3;
        }
        if(active == 4 && vrc70 == 1 && vrc71 == 1){
            return 5;
        }
        if(active == 6 && vrc70 == 2 && vrc71 == 1){
            return 7;
        }
        if(active == 8 && vrc70 == 3 && vrc71 == 1){
            return 9;
        }
        
        return this.activeHeatingCircuits();
    }
    activeHeatingCircuits():number{
        return this.getModuleConfigByName('heatingCircuits').getParameter();        
    }
    heatpumpCount(){
        if(this.getModuleConfigByName('heatPump').isAvailable()&& this.getModuleConfigByName('heatPump').getValue() != "no"){
            if(this.getModuleConfigByName('heatPump').getParameter() != undefined){
            	//this.debug("HEATPUMPS: "+this.getModuleConfigByName('heatPump').getParameter());
                return this.getModuleConfigByName('heatPump').getParameter();
            }else{
            	//this.debug("HEATPUMPS: 1");
                return 1;
            }
        }
        //this.debug("HEATPUMPS: 0");
        return 0;
    }
    hasBoiler(){
        return (this.getModuleConfigByName('boiler').isAvailable() && this.getModuleConfigByName('boiler').getValue() != "no");
    }
    boilerCount(){
        if(this.getModuleConfigByName('boiler').isAvailable() && this.getModuleConfigByName('boiler').getValue() != "no"){
            return  this.getModuleConfigByName('boiler').getParameter();
        }
        return 0;
    }
    hasBufferCylinder():boolean{
    	return this.getModuleConfigByName('bufferCylinder').isAvailable() && this.getModuleConfigByName('bufferCylinder').getValue() != "no";
    }
    hasHeatpump():boolean{
    	//this.debug("HAS HEATPUMPS: "+((this.getModuleConfigByName('heatPump').isAvailable() && this.getModuleConfigByName('heatPump').getValue() != "no")?"yes":"no"));
        return (this.getModuleConfigByName('heatPump').isAvailable() && this.getModuleConfigByName('heatPump').getValue() != "no");
    }
    hasAllStor(): boolean{
    	return this.getModuleConfigByName('bufferCylinder').getValue() == "allStor"; 
    }
    hasSolar():boolean{
    	return this.getModuleConfigByName('solarSystem').getValue() != "no";
    }
    ventilationCount():number{
    	
    	switch(this.getModuleConfigByName('ventilation').getValue()){
    		case 'no':{
    			return 0;
    		}
    		case 'yes':{
    			return 1;
    		}
    	}
    
    }
    solarCylinderCount():number{
    	switch(this.getModuleConfigByName('solarSystem').getValue()){
    		case 'no':{
    			return 0;
    		}
    		case 'one':{
    			return 1;
    		}
    		case 'two':{
    			return 2;
    		}
    		default:{
    			this.debug("ERR: unknown value for solarSystem");
    		}
    	}
    }
     getVR71Count(){

      let hcc :number = parseInt(this.activeHeatingCircuits().toString());

      if(
          ((hcc == 1 || hcc == 2) && (this.hasAllStor() || this.hasSolar()) ) ||
          ((hcc == 2) && ['de','be'].includes(this.getCountry()))

      ){
          return 1;
      }
      if([3,4,5,6,7,8,9].includes(hcc)){
          return 1;
      }
      if(this.heatpumpCount() > 1 || this.boilerCount() > 1){
          return 1;
      }
      return 0;
     }
  getVR70Count(){

    let hcc :number = parseInt(this.activeHeatingCircuits().toString());
    
    if(hcc == 1){
        return 0;
    }
    
    if(hcc == 2){
        if(this.hasAllStor() || this.hasSolar() || ['de','be'].includes(this.getCountry()) ){
            return 0;
        }else{
            return 1;
        }
    }
    
    if(hcc == 3){
        return 0;
    }
    
    if([4,5].includes(hcc)){
        return 1;
    }
    
    if([6,7].includes(hcc)){
        return 2;
    }
    
    if([8,9].includes(hcc)){
        return 3;
    }
    return 0;
  
  }


  
  getVariant(): 'vrc720'|'vrc720f'|'vrt380'|'vrt380f'{
        return this.variant;
  }
  has(id:string):boolean{
      switch(id.toLowerCase()){
          case 'greeniq':{
              return ['vrc720','vrc720f'].includes(this.getVariant());
          }
          case 'at-sensor':
          case 'outdoor-temperature-sensor':{
               return (this.regelungsstrategie() == 'witterungsgefuehrt' )|| ['vrc720','vrc720f'].includes(this.getVariant());
          }
          case 'humidity-sensor':{
              return ['vrc720','vrc720f'].includes(this.getVariant());
          }
      }
      return false;
  }
  
  isVRT380():boolean{
      return ['vrt380','vrt380f'].includes(this.getVariant());
  }

  regelungsstrategie(){
      if( this.moduleAvailable('regelungsstrategie') ){
          return ( this.getModuleConfigByName('regelungsstrategie').getValue() );
      }else{
        if(this.isVRT380()){
          return 'raumtemperaturgefuehrt';
        }
      }
  }
  hasRadio(){
      return ['vrc720f','vrc720_2f'].includes(this.variant);
  }
    hasBattery(){
      return ['vrc720f'].includes(this.variant);
  }

    isVariant(_variant: 'vrc720'|'vrc720f'):boolean{
        return this.variant == _variant;
    }
    setVariant(_variant: 'vrc720'|'vrc720f'){
        this.variant = _variant;
    }
}